<div class="flex justify-center items-center min-h-screen bg-slate-800 px-4">
  <mat-card class="max-w-md w-full p-7 sm:p-6 shadow-lg rounded-lg text-center bg-white">
    <img mat-card-image src="/assets/images/logositrack.png" alt="Logo Sitrack" class="mb-5 w-85 mx-auto">
    
    @if(isBetaEnvironment()) {
      <div class="my-4 p-3 sm:p-4 rounded-lg border-l-4 bg-yellow-50 border-l-yellow-500 text-yellow-800 animate-slide-in">
        <div class="flex items-start">
          <div class="flex-1">
            <mat-icon class="mr-2 sm:mr-3 mt-0.5 flex-shrink-0 text-base sm:text-lg">warning</mat-icon>
            <h4 class="m-0 mb-2 font-medium text-sm sm:text-base">Entorno de pruebas</h4>
            <p class="m-0 text-xs sm:text-sm leading-relaxed text-center">
              Estás accediendo a una versión beta del sistema.
              Si deseas utilizar la versión correcta, por favor dirígete a:
              <a href="https://admin.sitrackconectatuflota.com" class="text-blue-600 underline" target="_blank" rel="noopener noreferrer">admin.sitrackconectatuflota.com</a>
            </p>
          </div>
        </div>
      </div>
    }

    @if(isOldDomain()) {
      <div class="mb-4 p-3 sm:p-4 rounded-lg border-l-4 bg-red-50 border-l-red-500 text-red-800 animate-slide-in">
        <div class="flex items-start">
          <div class="flex-1">
            <mat-icon class="mr-2 sm:mr-3 mt-0.5 flex-shrink-0 text-base sm:text-lg">warning</mat-icon>
            <h4 class="m-0 mb-2 font-medium text-sm sm:text-base">Migración de dominio</h4>
            <p class="m-0 text-xs sm:text-sm leading-relaxed text-center">
              Esta página dejará de funcionar a partir del <strong>15 de enero del 2026</strong>. Para seguir usando el sistema, entra desde ahora a la nueva dirección:
              <a href="https://admin.sitrackconectatuflota.com" class="text-blue-600 underline" target="_blank" rel="noopener noreferrer">admin.sitrackconectatuflota.com</a>
              <br>
              <strong>Guarda la nueva dirección en tus favoritos.</strong>
            </p>
          </div>
        </div>
      </div>
    }

    <!-- Error Display -->
    @if (errorMessage) {
      <div class="flex items-start p-3 sm:p-4 mb-4 rounded-lg border-l-4 relative animate-slide-in" 
           [ngClass]="{
             'bg-red-50 border-l-red-500 text-red-800': currentError?.type === 'error' || !currentError?.type,
             'bg-amber-50 border-l-amber-500 text-amber-800': currentError?.type === 'warning',
             'bg-blue-50 border-l-blue-500 text-blue-800': currentError?.type === 'info'
           }">
        <mat-icon class="mr-2 sm:mr-3 mt-0.5 flex-shrink-0 text-base sm:text-lg">
          @switch (currentError?.type) {
            @case ('warning') { warning }
            @case ('info') { info }
            @default { error }
          }
        </mat-icon>
        <div class="flex-1">
          <h4 class="m-0 mb-2 font-medium text-sm sm:text-base">{{ currentError?.title || 'Error' }}</h4>
          <p class="m-0 text-xs sm:text-sm leading-relaxed text-start" [innerHTML]="formatErrorMessage(currentError?.message || errorMessage)"></p>
          @if (shouldShowRetry) {
            <button mat-stroked-button color="primary" (click)="retryLastAction()" class="mt-3 text-xs">
              <mat-icon class="text-sm">refresh</mat-icon>
              Reintentar
            </button>
          }
        </div>
        <button mat-icon-button (click)="clearError()" class="absolute top-1 sm:top-2 right-1 sm:right-2 w-7 h-7 sm:w-8 sm:h-8">
          <mat-icon class="text-sm sm:text-base">close</mat-icon>
        </button>
      </div>
    }

    <!-- Loading Indicator -->
    @if (isLoading) {
      <div class="mb-4 text-center">
        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
        <p class="mt-2 mb-0 text-sm text-gray-600">{{ loadingMessage }}</p>
      </div>
    }

    @if (!otpSent) {
      <app-email-input 
        [disabled]="isLoading"
        (emailSubmitted)="handleEmailSubmit($event)"
        (providerRegistrationRequested)="handleProviderRegistration($event)">
      </app-email-input>
    } @else {
      <app-otp-input 
        [email]="userEmail" 
        [disabled]="isLoading"
        (otpSubmitted)="handleOtpSubmit($event)" 
        (backToEmail)="handleBackToEmail()">
      </app-otp-input>
    }

  </mat-card>
</div>